module.exports = __webpack_public_path__ + "img/banner_bg.f0312d68.webp";